import { __values } from 'tslib';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var win = window;
if (win.addEventListener) {
    win.addEventListener('message', onmessage, false);
}
else if ((/** @type {?} */ (win)).attachEvent) {
    (/** @type {?} */ (win)).attachEvent('onmessage', onmessage);
}
else if (win.onmessage === null) {
    // eslint-disable-next-line unicorn/prefer-add-event-listener
    win.onmessage = onmessage;
}
/** @type {?} */
var subscribers = {};
/** @type {?} */
var prefix = '/*framebus*/';
/**
 * @param {?} origin
 * @return {?}
 */
function target(origin) {
    return {
        _origin: origin || '*',
        target: target,
        publish: publish,
        pub: publish,
        trigger: publish,
        emit: publish,
        subscribe: subscribe,
        sub: subscribe,
        on: subscribe,
        unsubscribe: unsubscribe,
        unsub: unsubscribe,
        off: unsubscribe
    };
}
/**
 * @param {?} event
 * @param {...?} args
 * @return {?}
 */
function publish(event) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    /** @type {?} */
    var origin = getOrigin(this); // eslint-disable-line no-invalid-this
    if (isntString(event) || isntString(origin)) {
        return false;
    }
    /** @type {?} */
    var payload = packagePayload(event, args, origin);
    if (payload === false) {
        return false;
    }
    broadcast(win.top || win.self, payload, origin);
    return true;
}
/**
 * @param {?} event
 * @param {?} fn
 * @return {?}
 */
function subscribe(event, fn) {
    /** @type {?} */
    var origin = getOrigin(this); // eslint-disable-line no-invalid-this
    if (subscriptionArgsInvalid(event, fn, origin)) {
        return false;
    }
    subscribers[origin] = subscribers[origin] || {};
    subscribers[origin][event] = subscribers[origin][event] || [];
    subscribers[origin][event].push(fn);
    return true;
}
/**
 * @param {?} event
 * @param {?} fn
 * @return {?}
 */
function unsubscribe(event, fn) {
    /** @type {?} */
    var origin = getOrigin(this); // eslint-disable-line no-invalid-this
    if (subscriptionArgsInvalid(event, fn, origin)) {
        return false;
    }
    /** @type {?} */
    var subscriberList = subscribers[origin] && subscribers[origin][event];
    if (!subscriberList) {
        return false;
    }
    for (var i = 0; i < subscriberList.length; i++) {
        if (subscriberList[i] === fn) {
            subscriberList.splice(i, 1);
            return true;
        }
    }
    return false;
}
/**
 * @param {?} scope
 * @return {?}
 */
function getOrigin(scope) {
    return scope && scope._origin || '*';
}
/**
 * @param {?} string
 * @return {?}
 */
function isntString(string) {
    return typeof string !== 'string';
}
/**
 * @param {?} event
 * @param {?} args
 * @param {?} origin
 * @return {?}
 */
function packagePayload(event, args, origin) {
    /** @type {?} */
    var packaged = false;
    /** @type {?} */
    var payload = {
        event: event,
        origin: origin,
        args: args
    };
    try {
        packaged = prefix + JSON.stringify(payload, function (key, value) {
            var _a;
            if (typeof value === 'function') {
                return _a = {}, _a[prefix] = subscribeReplier(value, origin), _a;
            }
            return value;
        });
    }
    catch (error) {
        throw new Error("Could not stringify event: " + error.message);
    }
    return packaged;
}
/**
 * @param {?} e
 * @return {?}
 */
function unpackPayload(e) {
    if (e.data.slice(0, prefix.length) !== prefix) {
        return false;
    }
    /** @type {?} */
    var replyOrigin = e.origin;
    /** @type {?} */
    var replySource = e.source;
    try {
        return JSON.parse(e.data.slice(prefix.length), function (key, value) {
            if (typeof value === 'object' && value !== null && prefix in value) {
                return function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    /** @type {?} */
                    var replyPayload = packagePayload(value[prefix], args, replyOrigin);
                    if (replyPayload === false) {
                        return false;
                    }
                    if (replySource) {
                        replySource.postMessage(replyPayload, replyOrigin);
                    }
                    else {
                        broadcast(win.top || win.self, replyPayload, replyOrigin);
                    }
                };
            }
            return value;
        });
    }
    catch (error) {
        return false;
    }
}
/**
 * @return {?}
 */
function uuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        /** @type {?} */
        var r = Math.random() * 16 | 0;
        /** @type {?} */
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        // tslint:enable:no-bitwise
        return v.toString(16);
    });
}
/**
 * @param {?} e
 * @return {?}
 */
function onmessage(e) {
    if (isntString(e.data)) {
        return;
    }
    /** @type {?} */
    var payload = unpackPayload(e);
    if (!payload) {
        return;
    }
    dispatch('*', payload.event, payload.args, e);
    dispatch(e.origin, payload.event, payload.args, e);
}
/**
 * @param {?} origin
 * @param {?} event
 * @param {?} args
 * @param {?} e
 * @return {?}
 */
function dispatch(origin, event, args, e) {
    var e_1, _a;
    if (!subscribers[origin] || !subscribers[origin][event]) {
        return;
    }
    try {
        for (var _b = __values(subscribers[origin][event]), _c = _b.next(); !_c.done; _c = _b.next()) {
            var subscriber = _c.value;
            subscriber.apply(e, args);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
/**
 * @param {?} frame
 * @param {?} payload
 * @param {?} origin
 * @return {?}
 */
function broadcast(frame, payload, origin) {
    /** @type {?} */
    var i = 0;
    /** @type {?} */
    var frameToBroadcastTo;
    try {
        frame.postMessage(payload, origin);
        // previously, our max value was frame.frames.length
        // but frames.length inherits from window.length
        // which can be overwritten if a developer does
        // `var length = value;` outside of a function
        // scope, it'll prevent us from looping through
        // all the frames. With this, we loop through
        // until there are no longer any frames
        // tslint:disable-next-line no-conditional-assignment
        while (frameToBroadcastTo = frame.frames[i]) { // eslint-disable-line no-cond-assign
            // eslint-disable-line no-cond-assign
            broadcast(frameToBroadcastTo, payload, origin);
            i++;
        }
    }
    catch (_) { /* ignored */
        /* ignored */ 
    }
}
/**
 * @param {?} fn
 * @param {?} origin
 * @return {?}
 */
function subscribeReplier(fn, origin) {
    /** @type {?} */
    var id = uuid();
    /**
     * @param {?} d
     * @param {?} o
     * @return {?}
     */
    function replier(d, o) {
        fn(d, o);
    }
    target(origin).subscribe(id, replier);
    return id;
}
/**
 * @param {?} event
 * @param {?} fn
 * @param {?} origin
 * @return {?}
 */
function subscriptionArgsInvalid(event, fn, origin) {
    return isntString(event) || typeof fn !== 'function' || isntString(origin);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { target, publish, subscribe, unsubscribe, uuid, publish as pub, publish as trigger, publish as emit, subscribe as sub, subscribe as on, unsubscribe as unsub, unsubscribe as off };

//# sourceMappingURL=ert-framebus.js.map